import dateUtil from '@/utils/date'

export default {
  methods: {
    date(payload) {
      return dateUtil(payload)
    }
  }
}
